import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublishQueuePage } from "@/components/admin/PublishQueuePage";

export const Route = createFileRoute("/_authenticated/admin/publish-queue")({
  beforeLoad: () => {
    throw redirect({ to: "/admin", search: { page: "publish-queue" } as never, replace: true });
  },
  head: () => ({
    meta: [
      { title: "Publish Queue — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: PublishQueuePage,
  errorComponent: ({ error }) => (
    <div className="p-8 text-sm text-rose-600">Failed to load: {(error as Error).message}</div>
  ),
  notFoundComponent: () => <div className="p-8">Not found</div>,
});
